// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2E3Q_","cell":"ColumnAccessor_cell__3O7ef","firstCellAccent":"ColumnAccessor_firstCellAccent__2hiD_"};